import http from '../http-common'

export default class AuthDataServices {
    async authenticate(data) {
        let res = http.post("v1/user/authenticate", data);
        return res;
    }
}